import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { i18n } from '../../../../language';
import DiaLog from '../../../../components/Dialog';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      // width: '80%',
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
}));

export default function UnCheckReminder({ open, closePop, handleUnCheckAll }) {
  const classes = useStyles();

  return (
    <DiaLog
      handleClose={closePop}
      handleCancel={closePop}
      handleConfirm={handleUnCheckAll}
      title={i18n.t('EHANDOVER_REMINDER')}
      cancel={i18n.t('EHANDOVER_COMMENT_CANCEL')}
      confirm={i18n.t('EHANDOVER_TASKITEM_CONFIRM')}
      dialogfootStyle={{ marginTop: '1rem' }}
      open={open}
      // maxWidth={false}
      className={classes.dialog}
    >
      <Box fontSize="1.142rem" fontWeight={500} mb="1.563rem">
        {i18n.t('EHANDOVER_CONFIRM_UNCHECK_ALL')}
      </Box>
    </DiaLog>
  );
}
